import { Navigate, Routes, Route, useParams } from 'react-router-dom';
import ClientLayout from '@/components/admin/ClientLayout';
import ClientBlankLayout from '@/components/admin/ClientBlankLayout';
import TransactionProductClient from '@/components/admin/TransactionProductClient';
import ClientMabarPage from '@/pages/client/ClientMabarPage';
import ClientMabarEventHasilPage from '@/pages/client/ClientMabarEventHasilPage';
import BadmintonStatistikPage from '@/pages/community/BadmintonStatistikPage';
import TambahBadmintonGamePage from '@/pages/community/TambahBadmintonGamePage';
import BadmintonEditSkorPage from '@/pages/community/BadmintonEditSkorPage';
import PadelStatistikPage from '@/pages/community/PadelStatistikPage';
import TambahPadelGamePage from '@/pages/community/TambahPadelGamePage';
import PadelEditSkorPage from '@/pages/community/PadelEditSkorPage';
import PadelSessionDetailPage from '@/pages/community/PadelSessionDetailPage';
import PickleballStatistikPage from '@/pages/community/PickleballStatistikPage';
import ClientMabarGameRekapPage from '@/pages/client/ClientMabarGameRekapPage';
import CreateMabarPage from '@/pages/client/CreateMabarPage';
import EditMabarPage from '@/pages/client/EditMabarPage';
import MabarDashboardPage from '@/pages/client/MabarDashboardPage';
import ClientDashboard from '@/pages/client/ClientDashboard';
import ClientBookingList from '@/pages/client/ClientBookingList';
import ClientBookingDetail from '@/pages/client/ClientBookingDetail';
import ClientMyCommunityPage from '@/pages/client/ClientMyCommunityPage';
import ClientDiscoveryPage from '@/pages/client/ClientDiscoveryPage';
import ClientDiscoveryEventPage from '@/pages/client/ClientDiscoveryEventPage';
import ClientDiscoveryCommunityPage from '@/pages/client/ClientDiscoveryCommunityPage';
import ClientDiscoveryBookingPage from '@/pages/client/ClientDiscoveryBookingPage';
import { ClientFieldDetailPage } from '@/pages/client/ClientFieldDetailPage';
import { ClientFieldPaymentMethodPage } from '@/pages/client/ClientFieldPaymentMethodPage';
import { ClientFieldPaymentInstructionPage } from '@/pages/client/ClientFieldPaymentInstructionPage';
import { ClientFieldPaymentSuccessPage } from '@/pages/client/ClientFieldPaymentSuccessPage';
import ClientProfilePage from '@/pages/client/ClientProfilePage';
import ClientAccountSettingsPage from '@/pages/client/ClientAccountSettingsPage';
import ClientCoHostCommunitiesPage from '@/pages/client/ClientCoHostCommunitiesPage';
import DeleteAccountPage from '@/pages/DeleteAccountPage';
import ClientChangePasswordPage from '@/pages/client/ClientChangePasswordPage';
import ClientStatsSettingsPage from '@/pages/client/ClientStatsSettingsPage';
import ClientMMRDetailPage from '@/pages/client/ClientMMRDetailPage';
import ClientMMRLeaderboardPage from '@/pages/client/ClientMMRLeaderboardPage';
import NotificationPage from '@/pages/client/NotificationPage';

import ClientCommunityDetailPage from '@/pages/client/ClientCommunityDetailPage';
import ClientCommunityMembersPage from '@/pages/client/ClientCommunityMembersPage';
import ClientCommunityEventsPage from '@/pages/client/ClientCommunityEventsPage';
import ClientMabarDetailPage from '@/pages/client/ClientMabarDetailPage';
import ClientMabarParticipantsPage from '@/pages/client/ClientMabarParticipantsPage';
import MabarCheckoutPage from '@/pages/client/MabarCheckoutPage';
import ClientExportMatchRecapPage from '@/pages/client/export/ClientExportMatchRecapPage';
import ClientMabarEventKelolaStatistikPage from '@/pages/client/ClientMabarEventKelolaStatistikPage';
import ClientTransactionDetailPage from '@/pages/client/ClientTransactionDetailPage';
import ClientPublicProfilePage from '@/pages/client/ClientPublicProfilePage';
import { clientPaths } from '@/utils/clientPaths';

function MabarToEventRedirect() {
  const { slug } = useParams<{ slug: string }>();
  return <Navigate to={`/event/${slug ?? ''}`} replace />;
}

const ClientPage = () => {
  return (
    <Routes>
      <Route path="mabar/:slug" element={<MabarToEventRedirect />} />
      <Route element={<ClientLayout />}>
        <Route index element={<ClientDashboard />} />
        <Route path="client" element={<Navigate to="/" replace />} />
        <Route path="booking" element={<ClientBookingList />} />
        <Route path="booking/:invoice_number" element={<ClientBookingDetail />} />
        <Route path="my-community" element={<ClientMyCommunityPage />} />
        <Route path="discovery" element={<ClientDiscoveryPage />} />
        <Route path="discovery/event" element={<ClientDiscoveryEventPage />} />
        <Route path="discovery/community" element={<ClientDiscoveryCommunityPage />} />
        <Route path="discovery/community/:slug/members" element={<ClientCommunityMembersPage />} />
        <Route path="discovery/community/:slug/events" element={<ClientCommunityEventsPage />} />
        <Route path="discovery/arena" element={<ClientDiscoveryBookingPage />} />
        <Route path="discovery/arena/:slug" element={<ClientFieldDetailPage />} />
        <Route path="community/:slug/members" element={<ClientCommunityMembersPage />} />
        <Route path="community/:slug/events" element={<ClientCommunityEventsPage />} />
        <Route path="mmr/leaderboard" element={<ClientMMRLeaderboardPage />} />
        <Route path="notification" element={<NotificationPage />} />
        <Route path="transactions" element={<TransactionProductClient />} />
        <Route path="transactions/booking/:invoice_number" element={<ClientTransactionDetailPage />} />
        <Route path="transactions/event/:order_number" element={<ClientTransactionDetailPage />} />
        <Route path="transactions/detail" element={<ClientTransactionDetailPage />} />
        <Route path="arena/payment" element={<ClientFieldPaymentMethodPage />} />
        <Route path="arena/checkout" element={<ClientFieldPaymentInstructionPage />} />
        <Route path="arena/payment-success" element={<ClientFieldPaymentSuccessPage />} />
        <Route path="arena/:slug" element={<ClientFieldDetailPage />} />
        <Route path="profile" element={<ClientProfilePage />} />
        <Route path="profile/account" element={<ClientAccountSettingsPage />} />
        <Route path="profile/account/communities" element={<ClientCoHostCommunitiesPage />} />
        <Route
          path="profile/account/delete"
          element={<DeleteAccountPage backTo={clientPaths.profile.account} />}
        />
        <Route path="profile/password" element={<ClientChangePasswordPage />} />
        <Route path="profile/stats" element={<ClientStatsSettingsPage />} />
        <Route path="profile/mmr" element={<ClientMMRDetailPage />} />
        <Route path="event" element={<ClientMabarPage />} />
        <Route path="event/create" element={<CreateMabarPage />} />
        <Route path="event/edit/:slug" element={<EditMabarPage />} />
        <Route path="event/dashboard/:slug" element={<MabarDashboardPage />} />
        <Route path="event/checkout" element={<MabarCheckoutPage />} />
        <Route path="event/checkout/:orderNumber" element={<MabarCheckoutPage />} />
        <Route path="event/:slug" element={<ClientMabarDetailPage />} />
        <Route path="event/:slug/participants" element={<ClientMabarParticipantsPage />} />
        <Route path="event/:slug/export" element={<ClientExportMatchRecapPage />} />
        <Route path="event/:slug/statistik" element={<ClientMabarEventHasilPage />} />
        <Route path="event/:slug/hasil" element={<ClientMabarEventHasilPage />} />
        <Route path="event/:slug/badminton" element={<BadmintonStatistikPage />} />
        <Route path="event/:slug/badminton/tambah-game" element={<TambahBadmintonGamePage />} />
        <Route
          path="event/:slug/badminton/game/:gameSlug/skor"
          element={<BadmintonEditSkorPage />}
        />
        <Route path="event/:slug/padel" element={<PadelStatistikPage />} />
        <Route path="event/:slug/padel/tambah-game" element={<TambahPadelGamePage />} />
        <Route
          path="event/:slug/padel/game/:gameSlug/skor"
          element={<PadelEditSkorPage />}
        />
        <Route path="event/:slug/padel/session/:sessionSlug" element={<PadelSessionDetailPage />} />
        <Route path="event/:slug/pickleball" element={<PickleballStatistikPage />} />
        <Route path="event/:slug/manage-share" element={<ClientMabarEventKelolaStatistikPage />} />
        <Route path="event/:slug/game/:gameSlug" element={<ClientMabarGameRekapPage />} />
      </Route>
      <Route element={<ClientBlankLayout />}>
        <Route path="discovery/community/:slug" element={<ClientCommunityDetailPage />} />
        <Route path="community/:slug" element={<ClientCommunityDetailPage />} />
        <Route path="profile/:username" element={<ClientPublicProfilePage />} />
      </Route>
    </Routes>
  );
};

export default ClientPage;
